import Component from "@glimmer/component";
import { service } from "@ember/service";

export default class SidebarOrganizationProjectSwitcher extends Component {
  @service router;
  @service intl;
  @service abilities;
  @service current;

  get organization() {
    return this.args.organization;
  }

  get projects() {
    return this.organization
      .hasMany("projects")
      .value()
      .slice()
      .sort((a, b) => a.locked - b.locked || a.displayName.localeCompare(b.displayName))
      .map((project) => {
        project.disabled = this.abilities.cannot("access project", project);
        return project;
      });
  }

  get currentProject() {
    return this.args.currentProject;
  }

  get jumpableRoute() {
    let findJumpable = function (route) {
      if (route?.metadata?.jumpable) {
        return route.name;
      }
      if (route?.parent) {
        return findJumpable(route.parent);
      }
      return "organization.overview";
    };

    return findJumpable(this.router.currentRoute);
  }

  projectChanged = (project) => (this.current.project = project);
}
